import { ClientErrorType } from "../types";
import { patientApi } from "./patientApi";

export const logsApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    createLog: builder.mutation<void, ClientErrorType>({
      query: (body) => ({
        url: `/api/logs`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useCreateLogMutation } = logsApi;
